var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('v-data-table',{attrs:{"headers":_vm.headers,"items":_vm.payouts},scopedSlots:_vm._u([{key:"item.createdAt",fn:function(ref){
var item = ref.item;
return [_vm._v(" "+_vm._s(_vm._f("date_format")(item.createdAt))+" ")]}},{key:"item.amountTransferred",fn:function(ref){
var item = ref.item;
return [_vm._v(" "+_vm._s(_vm._f("dollar_format")(item.amountTransferred))+" ")]}}],null,true)})],1)}
var staticRenderFns = []

export { render, staticRenderFns }